const stationArray = [
  {id: '1714da75-b278-4811-9877-acc200cfe747', project_id:'14740', key: 's-VE6wWlv8'},
  // {id: 'f3444470-c7e1-4567-bbde-d2b5635f46ed', project_id:'14740', key: 's-VE6wWlv8'}, Staging
  {id: '0796d2f6-2eb9-4917-836c-bc5e913bd8b8', project_id:'14740', key: 's-GZ8SbanD'},
  // {id: '4d911511-b605-481b-b2d0-d98050c4b0f4', project_id:'14740', key: 's-GZ8SbanD'}, Staging
  {id: '8c2bae50-38b7-4930-926e-2d22abdfa936', project_id:'14740', key: 's-AkcBDG3I'},
  // {id: '24ae1f41-1d6a-457b-a645-f5754486bf5f', project_id:'14740', key: 's-AkcBDG3I'}, Staging
  {id: 'f8f83a42-2b43-4fd5-970d-5203e4ee00a0', project_id:'14740', key: 's-BRgDVoTe'},
  // {id: '58c81a10-dbbc-42a5-ac53-ed987be03afd', project_id:'14740', key: 's-BRgDVoTe'}, Staging
  {id: '1fca5c3f-5803-4b59-935a-e31b0e71cd9b', project_id:'14740', key: 's-1DGn8Q4S'},
  // {id: '6737303a-80b7-4c43-9840-ec7ad8325864', project_id:'14740', key: 's-1DGn8Q4S'}, Staging
  {id: 'f9ad7a55-62ca-47ce-bb67-68a9967940cd', project_id:'14740', key: 's-P4tPMFmV'},
  // {id: 'e1045fdc-7447-48b8-ae29-f4ecd54c7ece', project_id:'14740', key: 's-P4tPMFmV'}, Staging
  {id: 'c027ac86-7fe1-41d5-b405-4e8a4d38038f', project_id:'14740', key: 's-jku1TCWL'},
  // {id: '69878c16-1b63-4a7e-83ad-2a0de201153d', project_id:'14740', key: 's-jku1TCWL'}, Staging
  {id: '0991a9ff-11ba-4748-a424-6605e0eda7e3', project_id:'14740', key: 's-AzdqYhl6'},
  // {id: '250f3fe9-bc72-4f04-b228-eadf41d9abd5', project_id:'14740', key: 's-AzdqYhl6'}, Staging
];


export const stationData = stationArray.reduce((ret, val) => {
  ret[val.id] = val;
  return ret;
}, {});
